/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';
import { Message } from 'element-ui';
import store from '../../store' //Vuex
import Cookies from 'js-cookie';
// 测试分支11

export let Header = {
    client: '',
    download: ''
}

// 环境的切换
if (process.env.NODE_ENV == 'development') {
    Header.client = 'riskPortal'
    Header.download = 'https://www.xjsmjjfw.com/risk-portal/api' //上传到服务器用这个 
    //Header.download = 'http://172.168.1.10:8100/risk-portal/api'//测试服务器
    axios.defaults.baseURL = '';

} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = window.OauthConfig.back_end;
    Header.download = window.OauthConfig.download

}


// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        if (config.url.includes('file/')) {

            axios.defaults.timeout = 1200000;
        } else {
            axios.defaults.timeout = 1200000;
        }
        let token = Cookies.get('tokenClient') || "";

        // if (!token && !code) {
        //   location.href = Header.login_url;
        // }
        config.headers['Authorization-Token'] = token;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        }
        return Promise.reject(response);
    },
    // 服务器状态码不是200的情况
    error => {
        // console.error(error);
        // console.log(error.response);
        if (error.response.data) {
            if (error.response.data.error == "invalid_grant" || error.response.data.error == "invalid_token") {
                //当code重复时 err:invalid_grant
                alert('err')
                location.href = Header.login_url;
            }
            if (error.response.data.error == 'access_denied' || error.response.data.error == 'unauthorized') {
                Message.error({
                    message: '对不起,暂无相关权限！请重新登录或联系管理员重试',
                    duration: 3000
                });
                return Promise.reject(error.response);
            }
        }
        // if (error.response.status) {}
    }
);
//状态码
const SUCCESS_CODE = 200;

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params
            })
            .then(res => {
                if (res.data.code != SUCCESS_CODE) {
                    Message.warning({
                        message: `服务器错误,状态码${res.data.code}`,
                        duration: 3000
                    });
                    return
                }
                resolve(res.data);
            })
            .catch(err => {
                Message.error({
                    message: `连接服务器失败,请刷新后重试!`,
                    duration: 3000
                });
                reject(err);
            }).finally(() => {
                setTimeout(() => {
                    store.commit('changeLoadingstate', false);
                }, 500)
            });
    });
}

export function getImg(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params,
                responseType: 'arraybuffer'
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]。
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params, Content = 'application/json') {
    console.log('###Content-Type',Content);
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                headers: {
                    'Content-Type': Content,
                    // 'Accept': '*/*'
                }
            })
            .then(res => {
                // if (res.data.code != SUCCESS_CODE) {
                //   Message.warning({
                //     message: `服务器错误,状态码${res.data.code}`,
                //     duration: 3000
                //   });
                //   return
                // }
                if (res.data.code === 500) {
                    Message.warning({
                        message: res.data.message,
                        duration: 3000
                    });
                    return
                } else if (res.data.code != SUCCESS_CODE) {
                    Message.warning({
                        message: `服务器错误,状态码${res.data.code}`,
                        duration: 3000
                    });
                    return
                }
                resolve(res.data);
            })
            .catch(err => {
                Message.error({
                    message: `连接服务器失败,请刷新后重试!`,
                    duration: 3000
                });
                reject(err);
            })
            .finally(() => {
                setTimeout(() => {
                    store.commit('changeLoadingstate', false);
                }, 500)
            });
    });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function del(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .delete(url, {
                params: params
            })
            .then(res => {
                if (res.data.code != SUCCESS_CODE) {
                    Message.warning({
                        message: `服务器错误,状态码${res.data.code}`,
                        duration: 3000
                    });
                    return
                }
                resolve(res.data);
            })
            .catch(err => {
                Message.error({
                    message: `连接服务器失败,请刷新后重试!`,
                    duration: 3000
                });
                reject(err);
            }).finally(() => {
                setTimeout(() => {
                    store.commit('changeLoadingstate', false);
                }, 500)
            });
    });
}

export function postToken(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, QS.stringify(params), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json'
                }
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}
export function postFormData(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                setTimeout(() => {
                    store.commit('changeLoadingstate', false);
                }, 500)
            });
    });
};

export function postLogin(url, params, Content = 'application/json') {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                headers: {
                    'Content-Type': Content,
                    // 'Accept': '*/*'
                }
            })
            .then(res => {
                //  console.log(res.data.code);
                if (res.data.code != SUCCESS_CODE) {
                    Message.warning({
                        message: `${res.data.message}`,
                        duration: 3000
                    });
                }
                resolve(res.data);
            })
            .catch(err => {
                Message.error({
                    message: `连接服务器失败,请刷新后重试!`,
                    duration: 3000
                });
                reject(err);
            })
            .finally(() => {
                setTimeout(() => {
                    store.commit('changeLoadingstate', false);
                }, 500)
            });
    });
}

export function postRegister(url, params, Content = 'application/json') {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                headers: {
                    'Content-Type': Content,
                    // 'Accept': '*/*'
                }
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                Message.error({
                    message: `连接服务器失败,请刷新后重试!`,
                    duration: 3000
                });
                reject(err);
            })
            .finally(() => {
                setTimeout(() => {
                    store.commit('changeLoadingstate', false);
                }, 500)
            });
    });
}
export function getBlob(url, params) {
  return new Promise((resolve, reject) => {
    axios
      ({
        method: 'get',
        url: url,
        responseType: 'blob',
        params: params,
      }
      )
      .then(res => {
        // if (res.data.code != SUCCESS_CODE) {
        //   Message.warning({
        //     message: `服务器错误,状态码${res.data.code}`,
        //     duration: 3000
        //   });
        //   return
        // }
        if (!res) {
          Message.error({
            message: "未成功获取文件",
            duration: 3000
          });
          return
        }
        resolve(res.data);
      })
      .catch(err => {
        Message.error({
          message: `连接服务器失败,请刷新后重试!`,
          duration: 3000
        });
        reject(err);
      }).finally(() => {
        setTimeout(() => {
          store.commit('changeLoadingstate', false);
        }, 500)
      });
  });
}

